import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    url: String,
    frameId: String
  }

  open() {
    if (!this.hasUrlValue || !this.urlValue) return

    const id = this.hasFrameIdValue && this.frameIdValue
      ? this.frameIdValue
      : "admin-snapshot-detail-modal"
    const frame = document.getElementById(id)
    if (!frame) return

    frame.src = this.urlValue
  }

  keydown(event) {
    if (event.key !== "Enter" && event.key !== " ") return

    event.preventDefault()
    this.open()
  }
}
